export module ViewComponentNames {
    export const bedViewComponent = "BedViewComponent";
    export const entranceDoorViewComponent = "EntranceDoorViewComponent";
    export const gangwayDoorViewComponent = "GangwayDoorViewComponent";
    export const innderDoorViewComponent = "InnerDoorViewComponent";
    export const nonUseableSpaceViewComponent = "NonUseableViewComponent";
    export const rackViewComponent = "RackViewComponent";
    export const adjustableSeatViewComponent = "AdjustableSeatViewComponent";
    export const seatWithStorageViewComponent = "SeatWithStorageViewComponent";
    export const stairViewComponent = "StairViewComponent";
    export const tableViewComponent = "TableViewComponent";
    export const wallViewComponent = "WallViewComponent";
    export const tableWithStorageViewComponent = "TableWithStorageViewComponent";
    export const luggageAreaViewComponent = "LuggageAreaViewComponent";
    export const overheadStorageViewComponent = "OverheadStorageViewComponent";
    export const aisleViewComponent = "AisleViewComponent";
    export const multipurposeareaViewComponent = "MultiPurposeAreaViewComponent";
    export const adjustablePTSeatViewComponent = "AdjustablePTSeatViewComponent";
    export const foldingSeatViewComponent = "FoldingSeatViewComponent";
    export const wheelChairBoardingDeviceViewComponent = "WheelChairBoardingDeviceViewComponent";
    export const cornerBenchViewComponent = "CornerBenchViewComponent";
    export const elementsInEntranceAreaViewComponent = "ElementsInEntranceAreaViewComponent";
    
    // use to copy and add apropriate description infront
    // export const ViewComponent = "ViewComponent";
}